
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {RecordModel} from '../../models/models';
import {FilterModel} from  '../../models/modelsFilter';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {LookupDialogComponent} from "../fields/LookupDialog";
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const ForeignKeyFilterComponent: React.FC<{
  filter: FilterModel,
  onChange: (value: any | null, filter: FilterModel) => void,
}> = ( {
  filter,
  onChange
}) => {

  const displayValue=filter.value.data?.lookup_display_value || '';

  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);
  const [lookupFieldObject, setLookupFieldObject] = useState<string | null>(null);

  const handleSearch = () => {
    if(filter.meta.objectApiName){
      setLookupFieldObject(filter.meta?.objectApiName);
      setOpenLookupDialog(!openLookupDialog);
    }
  }

  const handleClear = () => {
    onChange(null, filter)
    setLookupFieldObject(null)
    setOpenLookupDialog(false)
  }

  const handleChange = (newLookupValue: RecordModel | null) => {
    let thisRecord = null;
    if(newLookupValue){
      thisRecord = {Id_sys: newLookupValue.fields.Id_sys.fieldValue,
                    Uuid_sys: newLookupValue.fields.Uuid_sys.fieldValue,
                    lookup_display_value: newLookupValue.fields.lookup_display_value.fieldValue}
    }
    onChange(thisRecord, filter)
    setLookupFieldObject(null)
    setOpenLookupDialog(false)
  }

  return (
    <>
      <LookupDialogComponent
        objectApiName={lookupFieldObject}
        openDialog={openLookupDialog}
        onCloseDialog={() => {
              setLookupFieldObject(null)
              setOpenLookupDialog(false)
            }}
        onSelect={handleChange}
      />

      <TextField
         disabled
         label={filter.label}
         variant="filled"
         value={displayValue}
         InputProps={{
           disableUnderline: true,
           endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => handleSearch()}>
                  <SearchIcon />
                </IconButton>
                <IconButton size="small" onClick={() => handleClear()}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
        ),
         }}
      />
      </>
    );
};
